import { render } from "./MobileDropdownItem.vue?vue&type=template&id=4ba45d6e&scoped=true&ts=true"
import script from "./MobileDropdownItem.vue?vue&type=script&lang=ts"
export * from "./MobileDropdownItem.vue?vue&type=script&lang=ts"

import "./MobileDropdownItem.vue?vue&type=style&index=0&id=4ba45d6e&lang=less&scoped=true"

import exportComponent from "/Users/jiangshanwen/workspace/website-3.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba45d6e"]])

export default __exports__